import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Technician from "@/components/site/Technician";
import ShopShowcase from "@/components/site/ShopShowcase";
import Testimonials from "@/components/site/Testimonials";
import BookingContact from "@/components/site/BookingContact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-void text-zinc-100">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Technician />
        <ShopShowcase />
        <Testimonials />
        <BookingContact />
      </main>
      <Footer />
    </div>
  );
}
